// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3MMSS","header":"PatientQuestionnaire_header__3TKml","info":"PatientQuestionnaire_info__yJDYd"};